import { auditAuctionApi } from '@eastcoal/api/trade/auctionOperation/auditAuction'

import { ActionButton } from '@eastcoal/common/components/Button/ActionButton'
import { useFeedback } from '@eastcoal/common/hooks/useFeedback'
import { pick } from '@eastcoal/common/utils/object'

import { FormMode } from '@eastcoal/formily/components/CrudForm/enums/FormMode'
import { useCrudFormStore } from '@eastcoal/formily/components/CrudForm/Store/hooks/useStore'
import { CrudPopform } from '@eastcoal/formily/components/CrudPopform'
import { FormItem } from '@eastcoal/formily/components/FormItem'
import { RadioGroup } from '@eastcoal/formily/components/Radio'
import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'
import { TextArea } from '@eastcoal/formily/components/TextArea'

import { AuctionStatus } from '@eastcoal/shared/enums/AuctionStatus'

import { useAuctionListStore } from '../../../Store/hooks/useStore'

const schema: SchemaItem[] = [
  {
    name: 'id',
    type: 'string',
    'x-display': 'hidden'
  },
  {
    name: 'successful',
    type: 'boolean',
    title: '结果',
    enum: [
      {
        label: '通过',
        value: true
      },
      {
        label: '不通过',
        value: false
      }
    ],
    'x-component': RadioGroup,
    'x-decorator': FormItem
  },
  {
    name: 'reason',
    type: 'string',
    title: '原因',
    required: '{{ !$values.successful }}',
    'x-component': TextArea,
    'x-decorator': FormItem
  }
]

export const AuctionAuditButton = () => {
  const { message } = useFeedback()
  const { detailData, mode, onSuccess } = useCrudFormStore(state =>
    pick(state, ['detailData', 'mode', 'onSuccess'])
  )
  const { toggleDetailFormVisible } = useAuctionListStore(state =>
    pick(state, ['toggleDetailFormVisible'])
  )

  const handleAuditSuccess = () => {
    message.success('审核操作成功')
    toggleDetailFormVisible()
    onSuccess?.({}, {})
  }

  return mode === FormMode.READ &&
    detailData.status === AuctionStatus.WAIT_AUDIT ? (
    <CrudPopform
      api={auditAuctionApi}
      name='auditAuctionForm'
      schema={schema}
      title='审核'
      type='info'
      initialValues={{
        id: detailData.id,
        successful: true
      }}
      onSuccess={handleAuditSuccess}
    >
      <ActionButton type='primary'>审核</ActionButton>
    </CrudPopform>
  ) : null
}
